import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 700;

/**
 * useIsMobile - returns true when the viewport is narrower than 700px.
 *
 * Uses ResizeObserver on the document body for accurate detection. The
 * breakpoint matches our grid collapse threshold -- pages that use
 * `gridTemplateColumns: "1fr 1fr"` should switch to a single column below
 * this width.
 *
 * Usage:
 *   const isMobile = useIsMobile();
 *   ...
 *   <div style={{ gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr" }}>
 */
export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false,
  );

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", handler, { passive: true });
    handler(); // Sync on mount in case it changed before the effect ran
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);

  return isMobile;
}
